<mat-toolbar class="header">
  <a [routerLink]="['/welcome']"><div class="logo"></div></a>
  <span class="example-spacer"></span>
  <mat-button-toggle-group
    name="fontStyle"
    aria-label="Font Style"
    [value]="language$ | async"
    (change)="languageChange($event)"
    class="btn-toggle-group"
  >
    <mat-button-toggle [value]="translateNames.En" class="btn-toggle">EN</mat-button-toggle>
    <mat-button-toggle [value]="translateNames.Ru" class="btn-toggle">RU</mat-button-toggle>
  </mat-button-toggle-group>
  <app-button-multicolor [buttons]="buttons$ | async" (navigate)="navigateToRoute($event)"></app-button-multicolor>
</mat-toolbar>
